import { CircularProgress, TextField } from '@material-ui/core';
import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import apiService from '../../services/api/api.serivce';

type Auction = {
  id: number;
  name: string;
  auctionneer: string;
};
type Props = {
  onChange?: (auctionId: number | null) => void;
};
const AuctionAutocomplete: React.FC<Props> = ({ onChange }) => {
  const [searchString, setSearchString] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<Auction[]>([]);
  const loading = open && options.length === 0;

  React.useEffect(() => {
    let active = true;

    (async () => {
      const auctions = await apiService.getAuctions(searchString);

      if (active) {
        setOptions(auctions);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading, searchString]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const handleSearchChange = (event: any) => {
    setSearchString(event.target.value);
  };

  const handleSelected = (event: any, value: Auction | null) => {
    if (onChange) onChange(value?.id || null);
  };

  return (
    <Autocomplete
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      onChange={handleSelected}
      getOptionSelected={(option: any, value: any) => option.id === value.id}
      getOptionLabel={(option: any) => option.auctioneer + ' - ' + option.name}
      options={options}
      loading={loading}
      renderInput={(params: any) => (
        <TextField
          {...params}
          label="Search for an Auction"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            onChange: handleSearchChange,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default AuctionAutocomplete;
